





















































import { Getter } from "vuex-class";
import { Vue, Component } from 'vue-property-decorator';
import API from '@/Api';
const namespace: string = "AppStore";
import { ICodeTable , ISclModel, ISnackBar } from '@/models/Common';
import { __values } from 'tslib';


@Component
export default class Trainingplans extends Vue {
  @Getter("role", { namespace }) public role: any;
  // public employeeId: any = '';
  // public date: any = '';
  // public amount: any = '';
  // public email: any = '';
  public items: any = [];
  public Coursename: any = '';
  public Platform: any = '';
  public Courselink: any = '';
  public courserecommendlink: any = '';
  public Duration: any = '';
  public Amount: any = '';
  public Timeline: any = '';
  public contentid: any = '';
  public Newdata: any = '';
  public data: any = [];
  public eid: any = null;
  public hasCodeTableLoaded: boolean = false;
    public dataTable: ISclModel[] = [];

   

  


  public headers: any = [
    {
      text: 'Emp Id',
      align: 'left',
      sortable: false,
      value: 'EmployeeId',
    },
    {
      text: 'Name',
      align: 'left',
      sortable: false,
      value: 'FullName',
    },
    {
      text: 'HR BP Name',
      align: 'left',
      sortable: false,
      value: 'hrname',
    }
    ,
    {
      text: 'Date of Joining',
      align: 'left',
      sortable: false,
      value: 'crdate',
    }
    ,
    {
      text: 'Location',
      align: 'left',
      sortable: false,
      value: 'Location',
    }
    ,
    {
      text: 'Topic',
      align: 'left',
      sortable: false,
      value: 'topic',
    }
    ,
    {
      text: 'About',
      align: 'left',
      sortable: false,
      value: 'about',
    }
    
    ];



    public created() {
    // API.Instance.get('/api/code-table?id=14&seletedId=').then((response) => {
    //   this.hasCodeTableLoaded = true;
    //   this.loadData();
    // });
    this.loadData();
  }

  public mounted() {
    this.eid = this.$route.params.id;
    // if (this.hasCodeTableLoaded) {
      this.loadData();
    // }
  }

  public loadData() {
    API.Instance.get('/api/goalsettings/getconversationempInfo?eid='+this.eid).then((respone) => {
      this.dataTable = respone.data;
      this.items = respone.data;
    });
  }

  public submit()  {
    
    this.data ={
      Coursename:this.Coursename,
      courseplatform:this.Platform,
      courselink:this.Courselink,
      courserecommendlink:this.courserecommendlink,
      courseduration:this.Duration,
      courseamount:this.Amount,
      coursetimeline:this.Timeline,
      trainingplanid:this.contentid,
      Newdata:this.Newdata
    }
    API.Instance.post(
      '/api/trainingplans/inserttrainingplans',this.data,
    ).then((response) => {
      this.loadData();
      this.Coursename = '';
      this.Platform = '';
      this.Courselink = '';
      this.courserecommendlink = '';
      this.Duration = '';
      this.Amount = '';
      this.Timeline = '';
      this.$store.commit('AppStore/SNACK_BAR', {
        text: response.data,
        show: true,
      });
    });
  }


  public onClickToOpenLink(val:string){
    if(val.includes("http")){
      window.open(val,'blank')
    }

}



  // public submit() {
  //   API.Instance.post(
  //     `/api/trainingplans/inserttrainingplans?Coursename=${this.Coursename}&Platform=${this.Platform}
  //     &Courselink=${this.Courselink}&Duration=${this.Duration}&Amount=${this.Amount}&Timeline=${this.Timeline}&contentid=${this.contentid}`
  //   ).then((response) => {
  //     this.loadData();
  //     this.Coursename = '';
  //     this.Platform = '';
  //     this.Courselink = '';
  //     this.Duration = '';
  //     this.Amount = '';
  //     this.Timeline = '';
  //     this.$store.commit('AppStore/SNACK_BAR', {
  //       text: response.data,
  //       show: true,
  //     });
  //   });
  // }

  


  public editdata(item: any) {
     
      this.Coursename = item.coursename;
      this.Platform = item.courseplatform;
      this.Courselink = item.courselink;



      this.courserecommendlink = item.courserecommendlink;
      this.Duration = item.courseduration;
      this.Amount = item.courseamount;
      this.Timeline = item.coursetimeline;
      this.contentid=item.contentid;
      const scrollingElement = (document.scrollingElement || document.body);
      document.body.scrollTop = scrollingElement.scrollHeight;
      document.documentElement.scrollTop = scrollingElement.scrollHeight;
   
  }


  public deletedata(item: any) {
    API.Instance.post(
      '/api/trainingplans/deletetrainingplans?did='+item.contentid
    ).then((response) => {
      this.loadData();
      this.Coursename = '';
      this.Platform = '';
      this.Courselink = '';
      this.courserecommendlink = '';
      this.Duration = '';
      this.Amount = '';
      this.Timeline = '';
      this.$store.commit('AppStore/SNACK_BAR', {
        text: response.data,
        show: true,
      });
    });
  }
  
}

// function isLetterOrNumber(e) {
//             let char = String.fromCharCode(e.keyCode);
//             if (/^[A-Za-z0-9]+$/.test(char)) return true;
//             else e.preventDefault();
//         }

